import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const categoryLinks = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl font-bold text-foreground-900 tracking-tight">
                kakobuypolska<span className="text-primary-500">.site</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              {t('footer.quickLinks')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <a href="#o-czym" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">
                  {t('nav.spreadsheet')}
                </a>
              </li>
              <li>
                <a href="#bezpieczenstwo" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">
                  {t('nav.safety')}
                </a>
              </li>
              <li>
                <a href="#poradniki" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">
                  {t('nav.guides')}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150">
                  {t('nav.faq')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              {t('footer.categories')}
            </h4>
            <ul className="space-y-2">
              {categoryLinks.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-3">
              &nbsp;
            </h4>
            <ul className="space-y-2">
              {categoryLinks.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-150"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            {t('footer.disclaimer')}
          </p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}